module.exports = __webpack_public_path__ + "static/img/pods.91105c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/pods.png
// module id = UJtW
// module chunks = 0